
export default {
  props: {
    saving: Boolean,
    fixed: Boolean,
    reload: Boolean,
  },
};
